var React = require('react');

function CloseInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"clipRule":"evenodd","d":"m23.7803.218693c-.2929-.2928929-.7677-.2928929-1.0606 0l-10.7197 10.719707-10.71967-10.719707-.08412-.072618c-.29361-.2178542-.710274-.1936482-.97654.072618-.2928933.292894-.2928933.767767 0 1.060657l10.71963 10.71965-10.71963 10.7197-.072618.0841c-.2178547.2936-.1936486.7103.072618.9766.292893.2928.767767.2928 1.06066 0l10.71967-10.7197 10.7197 10.7197.0841.0726c.2936.2178.7103.1936.9765-.0726.2929-.2929.2929-.7678 0-1.0607l-10.7196-10.7197 10.7196-10.71965.0726-.08411c.2179-.293616.1937-.71028-.0726-.976547z","fill":"#b3b3b3","fillRule":"evenodd"}));
}

CloseInline.defaultProps = {"height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = CloseInline;

CloseInline.default = CloseInline;
